module.exports = __webpack_public_path__ + "static/media/parcel.ff9a626c.svg";